import { render, staticRenderFns } from "./CadastroPadrao.vue?vue&type=template&id=edd6e02c&"
import script from "./CadastroPadrao.vue?vue&type=script&lang=js&"
export * from "./CadastroPadrao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports